import type { Filter } from '@placer-ui/types';
import { FilterInsights } from 'core/entities/filter';

export const getFiltersForUrl = (filters?: Filter[] | FilterInsights[]) => {
    return filters?.map((filter) => {
        const filterAsFilter = filter as Filter;
        const filterAsFilterInsights = filter as FilterInsights;
        const label = {
            ...(filterAsFilter?.date_label && {
                chosenLabel: filterAsFilter.date_label,
            }),
            ...(filterAsFilterInsights?.date?.chosenLabel && {
                chosenLabel: filterAsFilterInsights?.date?.chosenLabel,
            }),
        };

        const startDate = filterAsFilter?.date_start ?? filterAsFilterInsights?.date?.start;
        const endDate = filterAsFilter?.date_end ?? filterAsFilterInsights?.date?.end;
        return {
            date:
                startDate && endDate
                    ? {
                          start: startDate,
                          end: endDate,
                          ...label,
                      }
                    : undefined,
            attributes: filter?.attributes,
            config: filter?.config,
        };
    });
};
